package com.example.mystybag.core.expected

import androidx.compose.ui.graphics.Color
import com.example.mystybag.common.resources.SR
import dev.icerock.moko.resources.ColorResource

/**
 * AUTO-GENERATED by :core:generateJsColorResourceExt from sharedResources colors.xml.
 * Do not edit this file manually.
 */
actual val ColorResource.composeColor: Color
    get() = when (this) {
        SR.colors.alertOrange -> Color(0xFFCD9020)
        SR.colors.amountGreen -> Color(0xFF64A180)
        SR.colors.background_black -> Color(0xFF191C1C)
        SR.colors.background_green -> Color(0xFF07B78D)
        SR.colors.background_light_blue -> Color(0xFF279BD8)
        SR.colors.background_red -> Color(0xFFDE3965)
        SR.colors.color_1CB78D -> Color(0xFF1CB78D)
        SR.colors.color_24B894 -> Color(0xFF24B894)
        SR.colors.color_2576AE -> Color(0xFF2576AE)
        SR.colors.color_2D2E2F -> Color(0xFF2D2E2F)
        SR.colors.color_3F3F3F -> Color(0xFF3F3F3F)
        SR.colors.color_51b990 -> Color(0xFF51B990)
        SR.colors.color_A54E4E -> Color(0xFFA54E4E)
        SR.colors.color_CF9D47 -> Color(0xFFCF9D47)
        SR.colors.color_ECA834 -> Color(0xFFECA834)
        SR.colors.color_F5B12B -> Color(0xFFF5B12B)
        SR.colors.color_F63059 -> Color(0xFFF63059)
        SR.colors.color_error -> Color(0xFF9A5351)
        SR.colors.color_f7505e -> Color(0xFFF7505E)
        SR.colors.color_f77155 -> Color(0xFFF77155)
        SR.colors.color_primary -> Color(0xFF279BD7)
        SR.colors.darkMode_background -> Color(0xFF131F37)
        SR.colors.main_white -> Color(0xFFFFFFFF)
        SR.colors.notification_icon_color -> Color(0xFF3EA4D7)
        SR.colors.referenceColor -> Color(0xFF2FC40A)
        SR.colors.sr_background -> Color(0xFFFFFFFF)
        SR.colors.sr_background_dm -> Color(0xFF16161A)
        SR.colors.sr_error -> Color(0xFFC82B2B)
        SR.colors.sr_error_container -> Color(0xFFFFEBEE)
        SR.colors.sr_error_container_dm -> Color(0xFFFFE2E2)
        SR.colors.sr_error_dm -> Color(0xFFC82B2B)
        SR.colors.sr_header_row_first_title -> Color(0xFF262727)
        SR.colors.sr_header_row_first_title_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_header_row_second_title -> Color(0xFF838689)
        SR.colors.sr_header_row_second_title_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_inverse_on_surface -> Color(0xFFE6E6E6)
        SR.colors.sr_inverse_on_surface_dm -> Color(0xFF333333)
        SR.colors.sr_inverse_primary -> Color(0xFF296812)
        SR.colors.sr_inverse_primary_dm -> Color(0xFF296812)
        SR.colors.sr_inverse_surface -> Color(0xFF262727)
        SR.colors.sr_inverse_surface_dm -> Color(0xFFE6E6E6)
        SR.colors.sr_navigation_bar -> Color(0xFFFFFFFF)
        SR.colors.sr_navigation_bar_dm -> Color(0xFF0A0A0A)
        SR.colors.sr_on_background -> Color(0xFF262727)
        SR.colors.sr_on_background_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_on_error -> Color(0xFFFFFFFF)
        SR.colors.sr_on_error_container -> Color(0xFFC82B2B)
        SR.colors.sr_on_error_container_dm -> Color(0xFF9A5351)
        SR.colors.sr_on_error_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_on_primary -> Color(0xFFFFFFFF)
        SR.colors.sr_on_primary_container -> Color(0xFF296812)
        SR.colors.sr_on_primary_container_dm -> Color(0xFF348227)
        SR.colors.sr_on_primary_dm -> Color(0xFFFEFEFE)
        SR.colors.sr_on_secondary -> Color(0xFFFFFFFF)
        SR.colors.sr_on_secondary_container -> Color(0xFF5E423E)
        SR.colors.sr_on_secondary_container_dm -> Color(0xFFA393E2)
        SR.colors.sr_on_secondary_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_on_surface -> Color(0xFF262727)
        SR.colors.sr_on_surface_dm -> Color(0xFFFEFEFE)
        SR.colors.sr_on_surface_variant -> Color(0xFF838689)
        SR.colors.sr_on_surface_variant_dm -> Color(0xFFBFBFBF)
        SR.colors.sr_on_tertiary -> Color(0xFFFFFFFF)
        SR.colors.sr_on_tertiary_container -> Color(0xFFEFC200)
        SR.colors.sr_on_tertiary_container_dm -> Color(0xFF60AFD7)
        SR.colors.sr_on_tertiary_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_outline -> Color(0xFFE2E2E1)
        SR.colors.sr_outline_dm -> Color(0xFF434343)
        SR.colors.sr_outline_variant -> Color(0xFFDCDCDC)
        SR.colors.sr_outline_variant_dm -> Color(0xFF23232C)
        SR.colors.sr_primary -> Color(0xFF2AA814)
        SR.colors.sr_primary_container -> Color(0xFFE8F9E4)
        SR.colors.sr_primary_container_dm -> Color(0xFFAFF99F)
        SR.colors.sr_primary_dm -> Color(0xFF2AA814)
        SR.colors.sr_scrim -> Color(0xFFFFFFFF)
        SR.colors.sr_scrim_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_secondary -> Color(0xFF5E423E)
        SR.colors.sr_secondary_container -> Color(0xFF348227)
        SR.colors.sr_secondary_container_dm -> Color(0xFF160E34)
        SR.colors.sr_secondary_dm -> Color(0xFF826BD7)
        SR.colors.sr_status_bar_background -> Color(0xFFFFFFFF)
        SR.colors.sr_status_bar_background_dm -> Color(0xFF0A0A0A)
        SR.colors.sr_status_bar_content -> Color(0xFF262727)
        SR.colors.sr_status_bar_content_dm -> Color(0xFFFFFFFF)
        SR.colors.sr_surface -> Color(0xFFFFFFFF)
        SR.colors.sr_surface_bright -> Color(0xFFFFFFFF)
        SR.colors.sr_surface_bright_dm -> Color(0xFF1C1C1C)
        SR.colors.sr_surface_container -> Color(0xFFDDDFDE)
        SR.colors.sr_surface_container_dm -> Color(0xFF353535)
        SR.colors.sr_surface_container_high -> Color(0xFFD5D7D6)
        SR.colors.sr_surface_container_high_dm -> Color(0xFF333333)
        SR.colors.sr_surface_container_highest -> Color(0xFFCFD1D0)
        SR.colors.sr_surface_container_highest_dm -> Color(0xFF4B4B4B)
        SR.colors.sr_surface_container_low -> Color(0xFFECEDEC)
        SR.colors.sr_surface_container_low_dm -> Color(0xFF0D0D0D)
        SR.colors.sr_surface_container_lowest -> Color(0xFFF0F0F0)
        SR.colors.sr_surface_container_lowest_dm -> Color(0xFF000000)
        SR.colors.sr_surface_dim -> Color(0xFFFFFFFF)
        SR.colors.sr_surface_dim_dm -> Color(0xFF0A0A0A)
        SR.colors.sr_surface_dm -> Color(0xFF1C1C1C)
        SR.colors.sr_tertiary -> Color(0xFFEFC200)
        SR.colors.sr_tertiary_container -> Color(0xFFE5EFF4)
        SR.colors.sr_tertiary_container_dm -> Color(0xFF0B212D)
        SR.colors.sr_tertiary_dm -> Color(0xFFEFC200)
        SR.colors.sr_widget_label_color -> Color(0xFF262727)
        SR.colors.sr_widget_label_color_dm -> Color(0xFF1C1C1C)
        SR.colors.tint_icon_color -> Color(0xFF279BD7)
        SR.colors.valueColor -> Color(0xFF2FC40A)
        SR.colors.vividBlue -> Color(0xFF2D5BE2)
        SR.colors.vividGreen -> Color(0xFF07B78D)
        SR.colors.vividPurple -> Color(0xFF8068D2)
        SR.colors.vividRed -> Color(0xFFDE3965)
        SR.colors.vividYellow -> Color(0xFFF8A90B)
        else -> Color(0xFFFFFFFF)
    }
